module.exports = __webpack_public_path__ + "img/pr-4.f5fe55d4.png";